import { Prop, Watch } from "vue-property-decorator";
import i18n from "@/i18n";
import Vue from "vue";

/**
 *  Класс для компоненты контролла суммы.
 */
export class SumInputVue extends Vue {
  
  /** внешнее значение v-model */
  @Prop() value!: string;

  /** название инпута */
  @Prop() label!: string;

  /** id инпута */
  @Prop() id!: string;

  /** цвет инпута */
  @Prop() color!: string;

  /** индикатор загрузки инпута */
  @Prop() loading!: boolean;

  /** индикатор изменяемости инпута */
  @Prop() readonly!: boolean;

  /** высота инпута */
  @Prop() height!: string;

  @Prop() suffix!: string;

  /** Правила при которых выводится ошибка */
  @Prop() rules!: Array<any>;

  /** Значение валюты */
  @Prop() CurrensySymbol!: string;

  @Watch("CurrensySymbol", { immediate: true })
  currencyChanged() {
    this.tryFormat(undefined);
  }

  @Watch("value", { immediate: true })
  valueChanged(val: any): void {
    if (!val && this.SumValue.length)
      return;
    this.SumValue = val.toString();
    this.tryFormat(undefined);
  }

  @Watch("SumValue", { immediate: true })
  sumValueChanged(val: any) {
    this.$emit("input", this.SumValue);
  }

  /** Позиция курсора */
  curPos: number = 0;

  /** внутреннее значение v-model */
  SumValue: string = "";

  error: boolean = false;

  defRules: Array<any> = [
    (p: any) =>
      (p !== null && p.substr(0, p.length - 2) !== "") ||
      i18n.t("main.operation.errors.sumError")
  ];

  /** Проверяем правила и вызываем событие блюр */
  checkRulesForReq() {
    const checkResult: boolean = this.id
      ? (this.$refs[this.id] as any).validate()
      : true;
    if (checkResult === true) {
      this.error = false;
      this.$emit("blur");
    } else {
      this.error = true;
    }
  }

  /** Изменяем позицию курсора */
  changeCursorPosition(e: any) {
    /** Если существует значение внутреннего v-model и знак валюты не пуст */
    if (this.SumValue && this.CurrensySymbol !== "") {
      /** Если позиция курсора равна длинне строки */
      if (e.selectionStart === this.SumValue.length) {
        e.selectionStart = e.selectionEnd = this.curPos;
      }
      /** Если существует значение внутреннего v-model без знака валюты */
    } else if (this.SumValue) {
      /** Если позиция курсора сейчас больше чем до исправления строки */
      if (e.selectionStart > this.curPos) {
        e.selectionStart = e.selectionEnd = this.curPos;
      }
    }
  }

  tryFormat(e: any) {
    /** Проверка на наличие самой суммы в объекте */
    if (this.SumValue === null) return;

    /** индекс того сколько элементов в конце нужно убирать при проверках: 2 если есть знак валюты(пробел+валюта) */
    let CurrensySymbolIndex = 0;
    if (this.CurrensySymbol === "") CurrensySymbolIndex = 0;
    else CurrensySymbolIndex = 2;

    /** Запоминаем количество пробелов до обработки строки */
    const beforeSPACES =
      this.SumValue.substr(0, this.SumValue.length - CurrensySymbolIndex).split(
        " "
      ).length - 1;
    let curStep = 0;

    /** ЗАПРЕТ НАПИСАНИЕ ЧЕГО ЛИБО ПОСЛЕ ЗНАКА ВАЛЮТЫ */
    if (
      this.SumValue.length > 2 &&
      CurrensySymbolIndex === 2 &&
      this.SumValue.substring(this.SumValue.length - 1) !==
        this.CurrensySymbol &&
      this.SumValue.indexOf(this.CurrensySymbol) !== -1
    ) {
      this.SumValue = this.SumValue.substring(0, this.SumValue.length - 1);
    }

    /** Проверка на первый ноль */
    if (
      this.SumValue.substr(0, 1) === "0" &&
      !isNaN(parseInt(this.SumValue.substr(1, 2)))
    )
      this.SumValue = this.SumValue.substr(1);

    /** Чистим все пробелы */
    this.SumValue = this.SumValue.split(" ").join("");
    this.SumValue = this.SumValue.split(".").join(",");

    /** Индекс запятой в строке */
    const dotIndex = this.SumValue.indexOf(",");

    /** Если валюта есть добавляем ее к строке с пробелом или без */
    if (CurrensySymbolIndex === 2) {
      if (this.SumValue.indexOf(`${this.CurrensySymbol}`) === -1) {
        this.SumValue += ` ${this.CurrensySymbol}`;
      } else {
        this.SumValue = this.SumValue.split(this.CurrensySymbol).join(
          ` ${this.CurrensySymbol}`
        );
      }
    }

    /** Массив не цифр, которые мы удалим */
    const letters = [];

    /** Не даем ввести не цифры */
    for (let i = 0; i < this.SumValue.length - CurrensySymbolIndex; i++) {
      const item = this.SumValue[i];
      if (isNaN(+item)) letters.push(item);
    }
    let k = 0; //счетчик запятых
    letters.map(letter => {
      if (letter !== ",") this.SumValue = this.SumValue.split(letter).join("");
      else if (k > 0) {
        this.SumValue =
          this.SumValue.substr(0, dotIndex + 1) +
          this.SumValue.substr(dotIndex + 1)
            .split(letter)
            .join("");
      }
      if (letter === ",") k++;
    });

    /** Раставляем пробелы так как нам надо */
    if (this.SumValue.length > CurrensySymbolIndex + 3) {
      let int = "";
      if (this.SumValue.substr(0, 1) !== ",") {
        int =
          this.SumValue.substr(0, this.SumValue.indexOf(",")) ||
          this.SumValue.substr(0, this.SumValue.indexOf(" ")) ||
          this.SumValue;
        for (let i = 0; i < int.length; i++) {
          if (i % 4 == 0) {
            int =
              int.substr(0, int.length - i) + " " + int.substr(int.length - i);
          }
        }
      }

      let frac = "";
      /** если запятая существует, то добавляем ее и дробную часть после числа с пробелами */
      if (dotIndex !== -1) {
        /** Округление дробной части до 2 цифер */
        if (this.SumValue.length - dotIndex > CurrensySymbolIndex + 3) {
          let lastSymbol = +this.SumValue.substring(
            this.SumValue.length - (CurrensySymbolIndex + 2),
            this.SumValue.length - (CurrensySymbolIndex + 1)
          );
          if (
            +this.SumValue.substring(
              this.SumValue.length - (CurrensySymbolIndex + 1),
              this.SumValue.length - CurrensySymbolIndex
            ) > 5
          ) {
            lastSymbol += 1;
          }
          this.SumValue = this.SumValue.substr(
            0,
            this.SumValue.length - (CurrensySymbolIndex + 2)
          );
          this.SumValue += lastSymbol === 10 ? 0 : lastSymbol;
          this.SumValue +=
            CurrensySymbolIndex === 2 ? ` ${this.CurrensySymbol}` : "";
          curStep = CurrensySymbolIndex === 2 ? -1 : 0;
        }
        frac = this.SumValue.substr(this.SumValue.indexOf(","));
      } else if (CurrensySymbolIndex === 2)
        frac = this.SumValue.substr(this.SumValue.indexOf(" "));
      this.SumValue = int.substr(0, int.length - 1) + frac;
    }

    /** Если существует событие на инпуте, то запоминаем позицию курсора */
    if (e !== undefined) {
      const lengthProp =
        CurrensySymbolIndex === 2
          ? this.SumValue.split(" ").length - 2
          : this.SumValue.split(" ").length - 1;
      if (beforeSPACES !== lengthProp) this.curPos = e.selectionStart + 1;
      else this.curPos = e.selectionStart + curStep;
    }
  }
}
